import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfilePictures.scss'
import defaultProfileImage from '../../../images/default-profile-picture.png'
import defaultCompanyImage from '../../../images/default-company-logo.png'
import { Row, Col } from 'react-bootstrap'
import PropTypes from 'prop-types';

class AdviserProfilePictures extends React.Component {

  static propTypes = {
    profilePicture: PropTypes.string,
    companyLogo: PropTypes.string
  };

  render () {
    const defaultProfilePicture = <img src={defaultProfileImage} />
    const defaultCompanyLogo = <img src={defaultCompanyImage} />

    const profilePicture = this.props.profilePicture ? <img src={this.props.profilePicture} /> : defaultProfilePicture
    const companyLogo = this.props.companyLogo ? <img src={this.props.companyLogo} /> : defaultCompanyLogo

    return (
      <Row>
        <Col xs={6} sm={6} md={6} lg={6} className={styles['profile-image']}>
          {profilePicture}
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} className={styles['company-profile-image']}>
          {companyLogo}
        </Col>
      </Row>
    )
  }

}

export default (AdviserProfilePictures)
